import { Plus } from "lucide-react";
import React from "react";
import './groups.css'
import { useNavigate } from "react-router-dom";

const NewGroup = () => {

  const navigate = useNavigate()

  return (
    <div className="card card-blank" onClick={() => navigate('/groups/group/add')}>
      <div className="card-content">
        <Plus style={{color: '#d1d5db'}} />
        <div style={{color: '#d1d5db'}}>Create a new group</div>
      </div>
    </div>
  );
};

export default NewGroup;
